import "./Spinner.css";

import React from "react";

const Spinner = ({ size = 20 }) => (
  <div
    className="Spinner"
    style={{ "--spinner-size": `${size}px` } as React.CSSProperties}
  ></div>
);

export default Spinner;
